module.exports = __webpack_public_path__ + "static/media/infoviz.fd6dc307.jpg";